import {
  CREATE_REVIEW,
  GET_RESTAURANT,
  GET_RESTAURANTS,
  GET_RESTAURANTS_WITH_ROUTES,
  GET_DISHES,
  SET_POINT,
  GET_REVIEWS,
  REQUEST_WAITER,
  DIVIDE_PAYCHECK,
  GET_PAYCHECK,
  GET_IMAGES,
  GET_CATEGORY_DISHES,
  RATE_DISH,
  SELECT_RESTAURANT,
  GET_RESTAURANTS_CATEGORIES,
  SELECT_CATEGORY,
  SORT_RESTAURANTS,
  GET_ROUTE_CATEGORIES,
  SET_MAP_VIEW,
  GET_COMPANIES,
  GET_COMPANY,
  GET_CATEGORY,
  GET_SORTED_DISHES,
  CHANGE_SORTED_DISHES,
  SET_ACTIVE_CATEGORY,
  TOGGLE_INITIAL_MENU_MODAL,
  SHOW_TERMINAL_MODAL,
  SET_SEEN_PROMOTED_SERVICE,
  SET_SALE_PRODUCTS,
  SET_PUBLIC_SALES
} from '../actions/RestaurantTypes';

const initialState = {
  restaurants: {},
  restaurantsLoaded: false,
  publicSales: [],
  routes: [],
  startPoint: {
    location: [],
    name: ''
  },
  endPoint: {
    location: [],
    name: ''
  },
  selectedRestaurant: 0,
  location: [],
  categories: {},
  selectedCategory: false,
  selectedSort: 'popular',
  allMapScanned: false,
  bounds: false,
  mapCenter: false,
  mapZoom: 10,
  companies: {},
  selectedRestaurantCategory: '',
  hideInitialModal: false,
  showTerminalModal: true,
  taxi: false,
  trips: [],
  journeys: [],
  mapServices: [],
  telegramGroups: [],
  seenPromotedServices: {}
};

export default function RestaurantsReducer(state = initialState, actions) {
  if (actions.type === SET_PUBLIC_SALES) {
    return {
      ...state,
      publicSales: actions.payload
    };
  }

  if (actions.type === SET_POINT) {
    return {
      ...state,
      [actions.payload.kind]: actions.payload.location
    };
  }

  if (actions.type === GET_RESTAURANTS_WITH_ROUTES) {
    return {
      ...state,
      restaurants: actions.payload,
      restaurantsLoaded: true,
      routes: actions.routes,
      routePolyline: actions.rawPolyline
    };
  }

  if (actions.type === GET_RESTAURANTS) {
    return {
      ...state,
      restaurants: actions.payload,
      restaurantsLoaded: true,
      location: actions.location,
      bounds: actions.bounds,
      allMapScanned: actions.allMapScanned,
      taxi: actions.taxi || false,
      trips: actions.trips || [],
      journeys: actions.journeys || [],
      mapServices: actions.mapServices || [],
      telegramGroups: actions.telegramGroups || []
    };
  }

  if (actions.type === GET_COMPANIES) {
    return {
      ...state,
      companies: Object.assign(actions.payload, state.companies)
    };
  }

  if (actions.type === GET_COMPANY) {
    let company = {};
    if (!!state.companies[actions.payload.slug]) {
      company = Object.assign(state.companies[actions.payload.slug], actions.payload);
    } else {
      company = actions.payload
    }
    return {
      ...state,
      companies: {
        ...state.companies,
        [actions.payload.slug]: company
      }
    };
  }

  if (actions.type === GET_RESTAURANT) {
    let restaurant = {};
    if (!!state.restaurants[actions.payload.slug]) {
      restaurant = Object.assign({}, state.restaurants[actions.payload.slug], actions.payload, { sales_loaded: true });
    } else {
      restaurant = Object.assign({}, actions.payload, { sales_loaded: true });
    }
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.payload.slug]: restaurant
      }
    };
  }

  if (actions.type === SELECT_RESTAURANT) {
    return {
      ...state,
      selectedRestaurant: actions.payload.id
    };
  }

  if (actions.type === GET_REVIEWS) {
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.restaurant.slug]: {
          ...state.restaurants[actions.restaurant.slug],
          reviews: actions.payload
        }
      }
    };
  }

  if (actions.type === CREATE_REVIEW) {
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.restaurant.slug]: Object.assign(actions.restaurant, { reviews: actions.payload })
      }
    };
  }

  if (actions.type === GET_DISHES) {
    if (!!state.restaurants[actions.restaurant.slug]) {
      return {
        ...state,
        restaurants: {
          ...state.restaurants,
          [actions.restaurant.slug]: {
            ...state.restaurants[actions.restaurant.slug],
            menu: actions.payload.dishes,
            [actions.payload.sort]: actions.payload[actions.payload.sort],
            sort: actions.payload.sort,
            available_collections: actions.payload.available_collections
          }
        }
      };
    } else {
      const restaurant = Object.assign(actions.restaurant,
        {
          menu: actions.payload.dishes, [actions.payload.sort]: actions.payload[actions.payload.sort],
          sort: actions.payload.sort, available_collections: actions.payload.available_collections
        });
      return {
        ...state,
        restaurants: {
          ...state.restaurants,
          [actions.restaurant.slug]: restaurant
        }
      };
    }
  }

  if (actions.type === GET_SORTED_DISHES) {
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.slug]: {
          ...state.restaurants[actions.slug],
          [actions.sort]: actions.payload,
          sort: actions.sort
        }
      }
    };
  }

  if (actions.type === CHANGE_SORTED_DISHES) {
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.slug]: {
          ...state.restaurants[actions.slug],
          sort: actions.payload
        }
      }
    };
  }

  if (actions.type === GET_CATEGORY) {
    const oldCategory = state.companies[actions.company.slug].categories[actions.categoryType].restaurants[actions.restaurant.id].menu[` ${actions.payload.id}`];
    return {
      ...state,
      companies: {
        ...state.companies,
        [actions.company.slug]: {
          ...state.companies[actions.company.slug],
          categories: {
            ...state.companies[actions.company.slug].categories,
            [actions.categoryType]: {
              ...state.companies[actions.company.slug].categories[actions.categoryType],
              restaurants: {
                ...state.companies[actions.company.slug].categories[actions.categoryType].restaurants,
                [actions.restaurant.id]: {
                  ...state.companies[actions.company.slug].categories[actions.categoryType].restaurants[actions.restaurant.id],
                  ...actions.restaurant,
                  menu: {
                    ...state.companies[actions.company.slug].categories[actions.categoryType].restaurants[actions.restaurant.id].menu,
                    [` ${actions.payload.id}`]: {
                      ...oldCategory,
                      ...actions.payload,
                      packable_dishes_count: oldCategory?.packable_dishes_count,
                      excluded_order_types: oldCategory?.excluded_order_types
                    }
                  }
                }
              }
            }
          }
        }
      }
    };
  }

  if (actions.type === REQUEST_WAITER) {
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.restaurant.slug]: {
          ...state.restaurants[actions.restaurant.slug],
          table: actions.payload
        }
      }
    };
  }

  if (actions.type === DIVIDE_PAYCHECK) {
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.restaurant.slug]: {
          ...state.restaurants[actions.restaurant.slug],
          table: {
            ...state.restaurants[actions.restaurant.slug].table,
            pay_check: actions.payload
          }
        }
      }
    };
  }

  if (actions.type === GET_PAYCHECK) {
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.restaurant.slug]: {
          ...state.restaurants[actions.restaurant.slug],
          table: actions.payload
        }
      }
    };
  }

  if (actions.type === GET_IMAGES) {
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.restaurant.slug]: {
          ...state.restaurants[actions.restaurant.slug],
          photos: actions.payload
        }
      }
    };
  }

  if (actions.type === GET_CATEGORY_DISHES) {
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.restaurant.slug]: {
          ...state.restaurants[actions.restaurant.slug],
          menu: {
            ...state.restaurants[actions.restaurant.slug].menu,
            [` ${actions.category.id}`]: {
              ...state.restaurants[actions.restaurant.slug].menu[` ${actions.category.id}`],
              photos_loaded: actions.category.photos_loaded,
              subItems: actions.payload
            }
          }
        }
      }
    };
  }

  if (actions.type === RATE_DISH) {
    const previousDishes = state.restaurants[actions.restaurant.slug].menu[` ${actions.category.id}`].subItems;
    const subItems = [...state.restaurants[actions.restaurant.slug].menu[` ${actions.category.id}`].subItems
      .filter((item) => item.sub_category_id === actions.payload.sub_category_id)];
    subItems[actions.dishIndex] = Object.assign(subItems[actions.dishIndex],
      { likes: actions.likes, dislikes: actions.dislikes });
    subItems.push(previousDishes.filter((item) => item.sub_category_id !== actions.payload.sub_category_id));
    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [actions.restaurant.slug]: {
          ...state.restaurants[actions.restaurant.slug],
          menu: {
            ...state.restaurants[actions.restaurant.slug].menu,
            [` ${actions.category.id}`]: {
              ...state.restaurants[actions.restaurant.slug].menu[` ${actions.category.id}`],
              subItems: [].concat.apply([], subItems)
            }
          }
        }
      }
    };
  }

  if (actions.type === GET_RESTAURANTS_CATEGORIES) {
    // const oldCategories = state.categories;
    const newCategories = actions.payload;
    // const categories = {};
    //
    // Object.keys(oldCategories).forEach((categoryKey) => {
    //   const oldCategory = oldCategories[categoryKey];
    //   const newCategory = Object.assign({}, oldCategory);
    //   if (newCategories.hasOwnProperty(categoryKey)) {
    //     const newCategoryRestaurants = newCategories[categoryKey].restaurants || {};
    //     const oldCategoryRestaurants = oldCategory.restaurants || {};
    //     newCategory.restaurants = Object.assign({}, oldCategoryRestaurants, newCategoryRestaurants);
    //   }
    //   categories[categoryKey] = newCategory;
    // });
    //
    // Object.keys(newCategories).forEach((categoryKey) => {
    //   if (!categories.hasOwnProperty(categoryKey)) {
    //     categories[categoryKey] = newCategories[categoryKey];
    //   }
    // });

    return {
      ...state,
      categories: newCategories
    };
  }

  if (actions.type === GET_ROUTE_CATEGORIES) {
    return {
      ...state,
      categories: actions.payload
    };
  }

  if (actions.type === SELECT_CATEGORY) {
    return {
      ...state,
      selectedCategory: actions.payload
    };
  }

  if (actions.type === SORT_RESTAURANTS) {
    return {
      ...state,
      selectedSort: actions.payload
    };
  }

  if (actions.type === SET_MAP_VIEW) {
    return {
      ...state,
      mapCenter: actions.payload,
      mapZoom: actions.zoom,
    };
  }

  if (actions.type === SET_ACTIVE_CATEGORY) {
    return {
      ...state,
      selectedRestaurantCategory: actions.payload
    };
  }

  if (actions.type === TOGGLE_INITIAL_MENU_MODAL) {
    return {
      ...state,
      hideInitialModal: actions.payload
    };
  }

  if (actions.type === SHOW_TERMINAL_MODAL) {
    return {
      ...state,
      showTerminalModal: actions.payload
    };
  }

  if (actions.type === SET_SEEN_PROMOTED_SERVICE) {
    return {
      ...state,
      seenPromotedServices: {
        ...state.seenPromotedServices,
        [actions.payload]: true
      }
    };
  }

  if (actions.type === SET_SALE_PRODUCTS) {
    const slug = actions.slug;
    const saleId = String(actions.saleId);
    const existingRestaurant = state.restaurants[slug] || {};
    const existingSaleProducts = existingRestaurant.sale_products || {};

    return {
      ...state,
      restaurants: {
        ...state.restaurants,
        [slug]: {
          ...existingRestaurant,
          sale_products: {
            ...existingSaleProducts,
            [saleId]: {
              sale: actions.sale,
              categories: actions.categories
            }
          }
        }
      }
    };
  }

  return state;
}
